import * as angular from "angular";

angular
  .module('app.permission')
  .config(permissionConfig);

/* @ngInject */
function permissionConfig($permissionProvider) {
  $permissionProvider.suppressUndefinedPermissionWarning(true);
}
